const countOperators = (query: string): number => {
  // eslint-disable-next-line no-useless-escape
  const re = /(\" \")|( OR [^\(])|( && [^\(])|( \|\| [^\(])|(( AND [^\(]))|(\" \()|(\( \")|(\) \")|(\) (NOT)|!)/g;
  return ((query || '').match(re) || []).length;
};

export default countOperators;
